import { Device } from '@repo/types'
import { useQuery } from 'react-query'

import { SpotifyDevicesStore } from '../SpotifyDevicesStore'
import { useSpotify } from '../useSpotify'

export function applyActiveDevice(devicesStore: SpotifyDevicesStore, queryResult: Device[]) {
  console.log('Devices query result:', JSON.stringify(queryResult, null, 4))

  const activeDevice = queryResult.find(device => device.isActive)

  if (!activeDevice) {
    console.log('No active device found. Resetting activeDevice...')
    devicesStore.apply({ activeDevice: undefined })
  } else {
    console.log('Applying activeDevice...', JSON.stringify(activeDevice))
    devicesStore.apply({ activeDevice })
  }
}

export function useQuerySpotifyDevices() {
  const { auth, deviceService, devices } = useSpotify()

  const { fn, key } = deviceService.query

  return useQuery(key, fn, {
    enabled: auth.isAuthenticated,
    onSuccess: data => {
      applyActiveDevice(devices, data)
    },
    refetchOnWindowFocus: true
  })
}
